// src/utils/util.ts
import { lodashUtil } from "@antv/l7-utils";
import rewind from "@mapbox/geojson-rewind";
function getColumn(data, columnName) {
  return data.map((item) => {
    return item[columnName] * 1;
  });
}
function isRasterFileData(data) {
  if (data === void 0) {
    return false;
  }
  if (!Array.isArray(data) && data.data !== void 0) {
    return true;
  } else {
    return false;
  }
}
function isRasterFileDataArray(data) {
  if (Array.isArray(data)) {
    if (data.length === 0) {
      return false;
    }
    if (isRasterFileData(data[0])) {
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
}
function isNumberArray(data) {
  if (Array.isArray(data)) {
    if (data.length === 0) {
      return true;
    }
    if (typeof data[0] === "number") {
      return true;
    } else {
      return false;
    }
  }
  return false;
}
function geojsonRewind(geojson) {
  const data = Object.isFrozen(geojson) ? lodashUtil.cloneDeep(geojson) : geojson;
  rewind(data, true);
  return data;
}
function extentToCoord(coord, extent) {
  return coord ? coord : [
    [extent[0], extent[3]],
    [extent[2], extent[3]],
    [extent[2], extent[1]],
    [extent[0], extent[1]]
  ];
}
export {
  extentToCoord,
  geojsonRewind,
  getColumn,
  isNumberArray,
  isRasterFileData,
  isRasterFileDataArray
};
